var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.computedColor,"disabled":_vm.loading,"dark":"","small":""}},[_vm._v(" "+_vm._s(_vm.statusType(_vm.data.status))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }